/**
 * GET /projects/:id/labor — implicit labor capture (Pillar B.4).
 *
 * Actual worked time derived from the task status timeline (never a manual
 * clock): per-task net minutes in the working state and person-minutes
 * (× crew). This is the actuals side of the estimate→actual margin loop
 * (E.1).
 */
import { z } from 'zod';
import { UuidSchema } from './common.js';
import { TaskStatusSchema, TaskTypeSchema } from './enums.js';
export const ProjectLaborTaskSchema = z.object({
    task_id: UuidSchema,
    title: z.string(),
    type: TaskTypeSchema,
    status: TaskStatusSchema,
    /** Net minutes the task spent in_progress (pauses excluded). */
    worked_minutes: z.number().int().min(0),
    crew_size: z.number().int().min(0),
    /** worked_minutes × crew_size — the labor-cost proxy. */
    person_minutes: z.number().int().min(0),
});
/**
 * Direct project work (D-3/A3/A5) — worked time when the crew Start/Finish the
 * PROJECT itself, no task. Derived from project_status_events the same way
 * task labor is derived from task_status_events; null when the project was never
 * worked directly (all work went through tasks). Its person_minutes are already
 * included in the response totals.
 */
export const ProjectLaborDirectSchema = z.object({
    /** Net minutes the project spent on_site (undo/redo brackets excluded). */
    worked_minutes: z.number().int().min(0),
    crew_size: z.number().int().min(0),
    person_minutes: z.number().int().min(0),
});
export const ProjectLaborResponseSchema = z.object({
    project_id: UuidSchema,
    tasks: z.array(ProjectLaborTaskSchema),
    /** Direct project work (A5), or null when the project was only worked via tasks. */
    project_level: ProjectLaborDirectSchema.nullable().default(null),
    total_worked_minutes: z.number().int().min(0),
    total_person_minutes: z.number().int().min(0),
    total_person_hours: z.number().min(0),
});
//# sourceMappingURL=project-labor.js.map